<template>
  <div>
    <div class="wrapHeader">
      <el-form :inline="true" class="demo-form-inline" :model="pickInfo">
        <el-form-item label="仓房选择">
          <el-select 
            v-model="pickInfo.wareId"
            @change='wareIdChange' 
            placeholder="仓房选择">
            <el-option 
              :label="item.wareName" 
              :value="item.wareId" 
              v-for='item in wareList' 
              :key='item.wareId'>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="采集时间">
          <el-select 
            v-model="pickInfo.grainId" 
            @change='grainIdChange' 
            @visible-change='canclBatchNo' 
            placeholder="采集时间">
            <el-option 
              :label="item.batchNo" 
              :value="item.grainId" 
              v-for='item in batchNoList' 
              :key='item.grainId'>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class='setBgImg' :style='`height:${height}px`'>
      <div class='showView' :style="`height:${height-20}px;width:${width-30}px`">
        <el-button type="primary" class='commonBtn harvestGrain' plain @click='harvestGrain'>{{type=='water'?'采集水分':'采集粮温'}}</el-button>
        <el-button type="primary" class="commonBtn moreGrain" plain @click="harvestMoreGrain">多仓采集</el-button>
        <el-button type="primary" class="commonBtn contrast" plain @click="harvestContrast">粮温对比</el-button>
        <el-button 
          type="primary" 
          class='commonBtn printGrain' 
          plain 
          @click='printGrain'>打印<i class="el-icon-printer el-icon--right"></i></el-button>
        <el-button 
          type="primary" 
          class='commonBtn printMoreGrain' 
          plain
          :disabled='isContrast' 
          @click='printMoreGrain'>多仓打印<i class="el-icon-printer el-icon--right"></i></el-button>
        <el-button type="primary" class="commonBtn grainExcel" plain @click="grainExcel">导出<i class="el-icon-document el-icon--right"></i></el-button>
        <div :class='["harvestStatus",tempStatus==0?"harvestStatus1":(tempStatus==1?"harvestStatus2":(tempStatus==2?"harvestStatus3":(tempStatus==3?"harvestStatus4":"harvestStatus5")))]'>{{getTempStatus}}</div>
        <div class='harvestTime'>上次采集时间：{{grainInfo.createTime}}</div>
        <div class='errorInfo'>{{errorInfo}}</div>
        <div class='wareTempInfo'>
          <div v-if='type=="water"'>
            <div v-if='waterSwitch' class='allTempWrap'>
              <div class='harvestTemp'>
                <span class='harvestVal'>{{grainInfo.humAve=='备用'||grainInfo.humAve=='故障'||grainInfo.humAve==''||grainInfo.humAve==null?'*':grainInfo.humAve+'%RH'}}</span>
                <span>平均湿度</span>
              </div>
              <div class='harvestTemp'>
                <span class='harvestVal'>{{grainInfo.humMax=='备用'||grainInfo.humMax=='故障'||grainInfo.humMax==''||grainInfo.humMax==null?'*':grainInfo.humMax+'%RH'}}</span>
                <span>最高湿度</span>
              </div>
              <div class='harvestTemp'>
                <span class='harvestVal'>{{grainInfo.humMin=='备用'||grainInfo.humMin=='故障'||grainInfo.humMin==''||grainInfo.humMin==null?'*':grainInfo.humMin+'%RH'}}</span>
                <span>最低湿度</span>
              </div>
            </div>
            <div v-else class='allTempWrap'>
              <div class='harvestTemp'>
                <span class='harvestVal'>{{grainInfo.waterAve=='备用'||grainInfo.waterAve=='故障'||grainInfo.waterAve==''||grainInfo.waterAve==null?'*':grainInfo.waterAve+'%'}}</span>
                <span>平均水分</span>
              </div>
              <div class='harvestTemp'>
                <span class='harvestVal'>{{grainInfo.waterMax=='备用'||grainInfo.waterMax=='故障'||grainInfo.waterMax==''||grainInfo.waterMax==null?'*':grainInfo.waterMax+'%'}}</span>
                <span>最高水分</span>
              </div>
              <div class='harvestTemp'>
                <span class='harvestVal'>{{grainInfo.waterMin=='备用'||grainInfo.waterMin=='故障'||grainInfo.waterMin==''||grainInfo.waterMin==null?'*':grainInfo.waterMin+'%'}}</span>
                <span>最低水分</span>
              </div>
            </div>
          </div>
          <div class='allTempWrap' v-else>
            <div class='harvestTemp'>
              <span class='harvestVal'>{{grainInfo.tempAve=='备用'||grainInfo.tempAve=='故障'||grainInfo.tempAve==''||grainInfo.tempAve==null?'*':grainInfo.tempAve+'°C'}}</span>
              <span>平均温度</span>
            </div>
            <div class='harvestTemp'>
              <span class='harvestVal'>{{grainInfo.tempMax=='备用'||grainInfo.tempMax=='故障'||grainInfo.tempMax==''||grainInfo.tempMax==null?'*':grainInfo.tempMax+'°C'}}</span>
              <span>最高温度</span>
            </div>
            <div class='harvestTemp'>
              <span class='harvestVal'>{{grainInfo.tempMin=='备用'||grainInfo.tempMin=='故障'||grainInfo.tempMin==''||grainInfo.tempMin==null?'*':grainInfo.tempMin+'°C'}}</span>
              <span>最低温度</span>
            </div>
          </div>
          <div>
            <div class='grainTempHum'>仓内温度：<span>{{grainInfo.tempIn=='备用'||grainInfo.tempIn=='故障'||grainInfo.tempIn==''||grainInfo.tempIn==null?'*':grainInfo.tempIn}}</span>°C</div>
            <div class='grainTempHum'>仓内湿度：<span>{{grainInfo.humidityIn=='备用'||grainInfo.humidityIn=='故障'||grainInfo.humidityIn==''||grainInfo.humidityIn==null?'*':grainInfo.humidityIn}}</span>%RH</div>
          </div>
          <div>
            <div class='grainTempHum'>仓外温度：<span>{{grainInfo.tempOut=='备用'||grainInfo.tempOut=='故障'||grainInfo.tempOut==''||grainInfo.tempOut==null?'*':grainInfo.tempOut}}</span>°C</div>
            <div class='grainTempHum'>仓外湿度：<span>{{grainInfo.humidityOut=='备用'||grainInfo.humidityOut=='故障'||grainInfo.humidityOut==''||grainInfo.humidityOut==null?'*':grainInfo.humidityOut}}</span>%RH</div>
          </div>
          <div v-if="heightInfo.n2">
            <div class='grainTempHum'>氮气浓度：<span>{{heightInfo.n2}}</span>%</div>
            <div class='grainTempHum'>粮面高度：<span>{{heightInfo.grainHeight}}</span>m</div>
          </div>
        </div>
        <div class='secondView grainTab' :style="`height:${height-120}px;width:${width-60}px`">
          <el-tabs v-model="activeName" type="card" class='delmarg'>
            <el-tab-pane label="数据表格" name="first">
              <div class='grainWrap' :style="`height:${height-180}px;width:${width-82}px`">
                <div v-if='type=="water"'>
                  <div v-if='waterSwitch'>
                    <div class="layerCard" v-if="activeLayer" style='top:0px'>
                      <div class="layerItem">
                        <div class="layerItemVal"><span>{{grainInfo.infos[activeLayer-1].infoHumAve+'%RH'}}</span></div>
                        <div class="layerItemName">层平均湿度</div>
                      </div>
                      <div class="layerItem">
                        <div class="layerItemVal"><span>{{grainInfo.infos[activeLayer-1].infoHumMax+'%RH'}}</span></div>
                        <div class="layerItemName">层最高湿度</div>
                      </div>
                      <div class="layerItem">
                        <div class="layerItemVal"><span>{{grainInfo.infos[activeLayer-1].infoHumMin+'%RH'}}</span></div>
                        <div class="layerItemName">层最低湿度</div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="layerCard" v-if="activeLayer" style='top:0px'>
                      <div class="layerItem">
                        <div class="layerItemVal"><span>{{grainInfo.infos[activeLayer-1].infoWaterAve+'%'}}</span></div>
                        <div class="layerItemName">层平均水分</div>
                      </div>
                      <div class="layerItem">
                        <div class="layerItemVal"><span>{{grainInfo.infos[activeLayer-1].infoWaterMax+'%'}}</span></div>
                        <div class="layerItemName">层最高水分</div>
                      </div>
                      <div class="layerItem">
                        <div class="layerItemVal"><span>{{grainInfo.infos[activeLayer-1].infoWaterMin+'%'}}</span></div>
                        <div class="layerItemName">层最低水分</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="layerCard" v-if="activeLayer"  style='top:0px'>
                    <div class="layerItem">
                      <div class="layerItemVal"><span>{{grainInfo.infos[activeLayer-1].tempAve+'°C'}}</span></div>
                      <div class="layerItemName">层平均温</div>
                    </div>
                    <div class="layerItem">
                      <div class="layerItemVal"><span>{{grainInfo.infos[activeLayer-1].tempMax+'°C'}}</span></div>
                      <div class="layerItemName">层最高温</div>
                    </div>
                    <div class="layerItem">
                      <div class="layerItemVal"><span>{{grainInfo.infos[activeLayer-1].tempMin+'°C'}}</span></div>
                      <div class="layerItemName">层最低温</div>
                    </div>
                  </div>
                </div>
                <div class='checkLayerWrap'>
                  <el-form :inline="true" class="demo-form-inline" v-if='pickInfo.wareType==0'>
                    <el-form-item label="选择层">
                      <el-select placeholder="选择层"  v-model='activeLayer'>
                        <el-option :label="item.name" :value="item.ind"  v-for='item in grainLayerList' :key='item.ind'></el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                  <el-switch
                    v-if='type=="water"'
                    style='margin-left:15px'
                    v-model="waterSwitch"
                    active-text="显示湿度"
                    inactive-text="显示水分">
                  </el-switch>
                </div>
                <div class='unitTips' v-if='type=="water"'>单位：{{waterSwitch?'%RH':'%'}}</div>
                <div class='unitTips' v-else>单位：℃</div>
                <div v-if='pickInfo.wareType==0'>
                  <div class='grainDataTable allGrain' :style="`height:${height-231}px`" v-if='activeLayer==0'>
                    <div class='cengWrap' v-for='(item,index) in pointList' :key='index'>
                      <div class='ceng layerTitle'>第{{index+1}}层</div>
                      <div class='ceng'>
                        <div class='hang'>
                          <div class='lie' :style='`width:${(width-300)/(item[0].length+1)}px`'>行/列</div>
                          <div class='lie' v-for='(lie,index) in item[0]' :key='index' :style='`width:${(width-300)/(item[0].length+1)}px`'>第{{index+1}}列</div>
                        </div>
                        <div class='hang' v-for='(row,index) in item' :key='index'>
                          <div class='lie' :style='`width:${(width-300)/(row.length+1)}px`'>第{{index+1}}行</div>
                          <div v-if='type=="water"' style='display:flex'>
                            <div 
                              :class='["lie",setMark(point)]' 
                              :style='`width:${(width-300)/(row.length+1)}px`' 
                              v-for='(point,index) in row' 
                              :key='index'>
                              {{waterSwitch?point.hum:point.water}}
                            </div>
                          </div>
                          <div v-else style='display:flex'>
                            <div 
                              :class='["lie",setMark(point)]' 
                              :style='`width:${(width-300)/(row.length+1)}px`' 
                              v-for='(point,index) in row' 
                              :key='index'>
                              {{point.value}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class='grainDataTable layerGrain' :style="`height:${height-231}px`" v-else>
                    <div class='cengWrap'>
                      <div class='ceng layerTitle'>第{{activeLayer}}层</div>
                      <div class='ceng'>
                        <div class='hang'>
                          <div class='lie' :style='`width:${(width-300)/(pointList[0][0].length+1)}px`'>行/列</div>
                          <div class='lie' v-for='(item,index) in pointList[0][0]' :key='index' :style='`width:${(width-300)/(pointList[0][0].length+1)}px`'>第{{index+1}}列</div>
                        </div>
                        <div class='hang' v-for='(item,index) in pointList[activeLayer-1]' :key='index'>
                          <div class='lie' :style='`width:${(width-300)/(item.length+1)}px`'>第{{index+1}}行</div>                      
                          <div v-if='type=="water"' style='display:flex'>
                            <div
                              :class='["lie",setMark(point)]' 
                              :style='`width:${(width-300)/(item.length+1)}px`' 
                              v-for='(point,index) in item' 
                              :key='index'>
                              {{waterSwitch?point.hum:point.water}}
                            </div>
                          </div>
                          <div v-else style='display:flex'>
                            <div 
                              :class='["lie",setMark(point)]' 
                              :style='`width:${(width-300)/(item.length+1)}px`' 
                              v-for='(point,index) in item' 
                              :key='index'>
                              {{point.value}}
                            </div>
                          </div>
                        </div>
                      </div> 
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class='grainDataTable siloGrain' :style="`height:${height-231}px`">
                    <div class='siloCengWrap' v-if='pointList[0]'>
                      <div class='hang'>
                        <div class='lie' :style='`width:${(width-100)/(siloGen+1)}px;height:80px`'>层/根/圈</div>
                        <div>
                          <div class='hang'>
                            <div class='siloTabTitle layerTitle' v-for='index in siloQuan' :key='index' :style='`width:${setLieWidth*pointList[0][index-1].length}px`'>第{{index}}圈</div>
                          </div>
                          <div class='hang'>
                            <div class='lie' v-for='ind in siloGen' :key='ind' :style='`width:${(width-100)/(siloGen+1)}px`'>第{{ind}}根</div>
                          </div>
                        </div>
                      </div>
                      <div class='hang' v-for='(ceng,index) in pointList' :key='index'>
                        <div class='lie' :style='`width:${(width-100)/(siloGen+1)}px`'>第{{index+1}}层</div>
                        <div v-for='(quan,index) in ceng' :key='index' class='siloQuan'>
                          <div v-if='type=="water"' style='display:flex'>
                            <div 
                              :class='["lie",setMark(point)]' 
                              v-for='(point,index) in quan' 
                              :key='index' 
                              :style='`width:${(width-100)/(siloGen+1)}px`'>
                              {{waterSwitch?point.hum:point.water}}
                            </div>
                          </div>
                          <div v-else style='display:flex'>
                            <div 
                              :class='["lie",setMark(point)]' 
                              v-for='(point,index) in quan' 
                              :key='index' 
                              :style='`width:${(width-100)/(siloGen+1)}px`'>
                              {{point.value}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="三维展示" name="second">
              <div class='grainWrap' :style="`height:${height-182}px`">
                <div class="grain3DWrap">
                  <div class='check3DLayerWrap'>
                    <el-form :inline="true" class="demo-form-inline">
                      <el-form-item label="选择层">
                        <el-select placeholder="选择层"  v-model='activeLayer'>
                          <el-option :label="item.name" :value="item.ind"  v-for='item in grainLayerList' :key='item.ind'></el-option>
                        </el-select>
                      </el-form-item>
                    </el-form>
                    <el-switch
                      v-if='type=="water"'
                      style='margin-left:15px'
                      v-model="waterSwitch"
                      active-text="显示湿度"
                      inactive-text="显示水分">
                    </el-switch>
                  </div>
                  <div v-if='type=="water"'>
                    <div v-if='waterSwitch'>
                      <div class="layerCard" v-if="activeLayer">
                        <div class="layerItem">
                          <div class="layerItemVal"><span>{{grainInfo.infos[activeLayer-1].infoHumAve+'%RH'}}</span></div>
                          <div class="layerItemName">层平均湿度</div>
                        </div>
                        <div class="layerItem">
                          <div class="layerItemVal"><span>{{grainInfo.infos[activeLayer-1].infoHumMax+'%RH'}}</span></div>
                          <div class="layerItemName">层最高湿度</div>
                        </div>
                        <div class="layerItem">
                          <div class="layerItemVal"><span>{{grainInfo.infos[activeLayer-1].infoHumMin+'%RH'}}</span></div>
                          <div class="layerItemName">层最低湿度</div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="layerCard" v-if="activeLayer">
                        <div class="layerItem">
                          <div class="layerItemVal"><span>{{grainInfo.infos[activeLayer-1].infoWaterAve+'%'}}</span></div>
                          <div class="layerItemName">层平均水分</div>
                        </div>
                        <div class="layerItem">
                          <div class="layerItemVal"><span>{{grainInfo.infos[activeLayer-1].infoWaterMax+'%'}}</span></div>
                          <div class="layerItemName">层最高水分</div>
                        </div>
                        <div class="layerItem">
                          <div class="layerItemVal"><span>{{grainInfo.infos[activeLayer-1].infoWaterMin+'%'}}</span></div>
                          <div class="layerItemName">层最低水分</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="layerCard" v-if="activeLayer">
                      <div class="layerItem">
                        <div class="layerItemVal"><span>{{grainInfo.infos[activeLayer-1].tempAve+'°C'}}</span></div>
                        <div class="layerItemName">层平均温</div>
                      </div>
                      <div class="layerItem">
                        <div class="layerItemVal"><span>{{grainInfo.infos[activeLayer-1].tempMax+'°C'}}</span></div>
                        <div class="layerItemName">层最高温</div>
                      </div>
                      <div class="layerItem">
                        <div class="layerItemVal"><span>{{grainInfo.infos[activeLayer-1].tempMin+'°C'}}</span></div>
                        <div class="layerItemName">层最低温</div>
                      </div>
                    </div>
                  </div>
                  <div class="cardWrap">
                    <div class="cardHead">数据卡片</div>
                    <div class="cardItem">
                      <div class="cardName">粮食品种</div>
                      <div class="cardValue"><dict-tag :options="foodFariety" :value="wareInfo.foodFariety"/></div>
                    </div>
                    <div class="cardItem">
                      <div class="cardName">粮食性质</div>
                      <div class="cardValue"><dict-tag :options="dict.type.food_type" :value="wareInfo.foodType"/></div>
                    </div>
                    <div class="cardItem">
                      <div class="cardName">粮食等级</div>
                      <div class="cardValue"><dict-tag :options="dict.type.food_level" :value="wareInfo.foodLevel"/></div>
                    </div>
                    <div class="cardItem">
                      <div class="cardName">粮食产地</div>
                      <div class="cardValue">{{wareInfo.origin}}</div>
                    </div>
                    <div class="cardItem">
                      <div class="cardName">实际储量</div>
                      <div class="cardValue">{{wareInfo.storageReal}} kg</div>
                    </div>
                    <div class="cardItem">
                      <div class="cardName">仓房高度</div>
                      <div class="cardValue">{{wareInfo.height}} m</div>
                    </div>
                    <div class="cardItem">
                      <div class="cardName">保管员</div>
                      <div class="cardValue">{{wareInfo.custodian}}</div>
                    </div>
                  </div>
                  <div class="ware3DWrap" 
                    :style="`transform:rotateY(${leavalY}deg) rotateX(${leavalX}deg);`"
                    v-if='pickInfo.wareType==0' 
                    @mousedown="startDrag($event)">
                    <div class="wareLeftfront"></div>
                    <div class="wareLeftleft"></div>
                    <div class="wareLeftright"></div>
                    <div class="wareLefttop"></div>
                    <div class="wareBackfront"></div>
                    <div class="wareBackright"></div>
                    <div class="wareBacktop"></div>
                    <div class="wareBottomtop"></div>
                    <div class="wareBottombottom"></div>
                    <div class="wareBottomfront"></div>
                    <div class="wareBottomleft"></div>
                    <div class="wareBottomright"></div>
                    <div class="wareRightfront"></div>
                    <div class="wareRightright"></div>
                    <div class="wareRighttop"></div>
                    <div class="wareToptop"></div>
                    <div class="wareTopfront"></div>
                    <div 
                      :class='["wareDataShow",activeLayer==0||activeLayer==(ind+1)?"isTempDataShow":""]' 
                      :style='`transform: rotateX(90deg) translateX(10px) translateY(5px) translateZ(${250-(500/pointList.length)*(0.5+ind)}px);`' 
                      v-for='(item,ind) in pointList' 
                      :key='`ind${ind}`'>
                      <div class='dataShowGen' v-for='(gen,index) in item' :key='index' v-if='activeLayer==0||activeLayer==(ind+1)'>
                        <div class='dataShowLie' v-for="(lie,index) in gen" :key='index'>
                          <div 
                            v-if='type=="water"'
                            :class="['dataShowValue',setMark(lie)]" 
                            :style='`background-color:${setStyle(lie)}`'>
                            <span style="background-color:black;padding:2px 5px">
                              {{waterSwitch?lie.hum:lie.water}}
                            </span>
                          </div>
                          <div 
                            v-else
                            :class="['dataShowValue',setMark(lie)]" 
                            :style='`background-color:${setStyle(lie)}`'>
                            <span style="background-color:black;padding:2px 5px">
                              {{lie.value}}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div 
                      :class='["wareDataShow",activeLayer==0||activeLayer==(i+1)?"isTempDataShow":""]' 
                      :style='`transform: rotateX(90deg) translateX(10px) translateY(5px) translateZ(${250-(500/pointList.length)*(0.5+i)-10}px);`' 
                      v-for='(item,i) in pointList' 
                      :key='`i${i}`'></div>
                    <div 
                      :class='["wareDataShowfront",activeLayer==0||activeLayer==(index+1)?"iswareDataShowfront":""]' 
                      :style='`transform: translateZ(250px) translateX(10px) translateY(${(500/pointList.length)*(0.5+index)-5}px)`' 
                      v-for='(item,index) in pointList' 
                      :key='index'></div>
                    <div 
                      :class='["wareDateShowright",activeLayer==0||activeLayer==(index+1)?"iswareDataShowright":""]' 
                      :style='`transform: rotateY(-90deg) translateZ(-540px) translateY(${(500/pointList.length)*(0.5+index)-5}px)`'  
                      v-for='(item,index) in pointList' 
                      :key='`index${index}`'></div>
                    <div class="wareCengWrap">
                      <div class="wareCengItem" v-for='(item,index) in pointList' :key='index'>第{{index+1}}层</div>
                    </div>
                    <div class="wareLieWrap" v-if='pointList[0]'>
                      <div class="wareLieItem" v-for='(item,index) in pointList[0][0]' :key='index'>第{{index+1}}列</div>
                    </div>
                    <div class="wareHangWrap">
                    <div class="wareHangItem" v-for='(item,index) in pointList[0]' :key='index'>第{{index+1}}行</div>
                    </div>
                  </div>
                  <div 
                    class='silo3DWrap' 
                    :style="`transform:rotateZ(${leavalY}deg) rotateX(${leavalX}deg);`" 
                    v-else 
                    @mousedown="startDrag($event)">
                    <div class="siloWall" v-for='index in 36' :key='index' :style='`transform:rotateY(${index*5}deg);`'></div>
                    <div 
                      class="siloBottom" 
                      :style='`transform: rotateX(90deg) translateZ(${-150+index}px);`' 
                      v-for='index in 5' 
                      :key='`index${index}`'></div>
                    <div class="siloBottom siloTop" style='transform: rotateX(90deg) translateZ(250px);'></div>
                    <div 
                      class='siloBottom siloDataShow' 
                      :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+index)}px);`' 
                      v-for='(ceng,index) in pointList' 
                      :key='`silo${index}`' 
                      v-if='activeLayer==0||activeLayer==(index+1)'>
                      <div class='siloDataShowWarp'>
                        <div class='siloDataQuanWrap' v-for='(quan,quanInd) in ceng' :key='quanInd' :style='`z-index:${100-quanInd*5}`'>
                          <div 
                            v-if='type=="water"'
                            class='siloDataQuan' 
                            :style='`width:${(500/ceng.length)*quanInd}px;height:${(500/ceng.length)*quanInd}px;z-index:${100-quanInd};}`'>
                            <div
                              :class='["siloDataLie",setMark(lie)]' 
                              v-for='(lie,index) in quan' 
                              :key='`lie${index}`' 
                              :style='`background-color:${setStyle(lie)};transform: rotate(${(360/quan.length)*index}deg);transform-origin: 25px ${(250/ceng.length)*quanInd+25}px;visibility:${lie.water?"visible":"hidden"}`'>
                              <div>
                                <span style="background-color:black;padding:2px 5px">
                                  {{waterSwitch?lie.hum:lie.water}}
                                </span>
                              </div>
                              <div style='font-size:12px'>第{{lie.gen}}根</div>
                            </div>
                          </div>
                          <div 
                            v-else
                            class='siloDataQuan' 
                            :style='`width:${(500/ceng.length)*quanInd}px;height:${(500/ceng.length)*quanInd}px;z-index:${100-quanInd};}`'>
                            <div
                              v-if="lie.value"
                              :class='["siloDataLie",setMark(lie)]' 
                              v-for='(lie,index) in quan' 
                              :key='`lie${index}`' 
                              :style='`background-color:${setStyle(lie)};transform: rotate(${(360/quan.length)*index}deg);transform-origin: 25px ${(250/ceng.length)*quanInd+25}px;`'>
                              <div>
                                <span style="background-color:black;padding:2px 5px">
                                  {{lie.value}}
                                </span>
                              </div>
                              <div style='font-size:12px'>第{{lie.gen}}根</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div :class='["siloBottom",activeLayer==0||activeLayer==1?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5)-ind}px);`' v-for='ind in 5' :key='`bot1${ind}`' v-if='pointList.length>=1'></div>
                    <div :class='["siloBottom",activeLayer==0||activeLayer==2?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+1)-ind}px);`' v-for='ind in 5' :key='`bot2${ind}`' v-if='pointList.length>=2'></div>
                    <div :class='["siloBottom",activeLayer==0||activeLayer==3?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+2)-ind}px);`' v-for='ind in 5' :key='`bot3${ind}`' v-if='pointList.length>=3'></div>
                    <div :class='["siloBottom",activeLayer==0||activeLayer==4?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+3)-ind}px);`' v-for='ind in 5' :key='`bot4${ind}`' v-if='pointList.length>=4'></div>
                    <div :class='["siloBottom",activeLayer==0||activeLayer==5?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+4)-ind}px);`' v-for='ind in 5' :key='`bot5${ind}`' v-if='pointList.length>=5'></div>
                    <div :class='["siloBottom",activeLayer==0||activeLayer==6?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+5)-ind}px);`' v-for='ind in 5' :key='`bot6${ind}`' v-if='pointList.length>=6'></div>
                    <div :class='["siloBottom",activeLayer==0||activeLayer==7?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+6)-ind}px);`' v-for='ind in 5' :key='`bot7${ind}`' v-if='pointList.length>=7'></div>
                    <div :class='["siloBottom",activeLayer==0||activeLayer==8?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+7)-ind}px);`' v-for='ind in 5' :key='`bot8${ind}`' v-if='pointList.length>=8'></div>
                    <div :class='["siloBottom",activeLayer==0||activeLayer==9?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+8)-ind}px);`' v-for='ind in 5' :key='`bot9${ind}`' v-if='pointList.length>=9'></div>
                    <div :class='["siloBottom",activeLayer==0||activeLayer==10?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+9)-ind}px);`' v-for='ind in 5' :key='`bot10${ind}`' v-if='pointList.length>=10'></div>
                    <div :class='["siloBottom",activeLayer==0||activeLayer==11?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+10)-ind}px);`' v-for='ind in 5' :key='`bot11${ind}`' v-if='pointList.length>=11'></div>
                    <div :class='["siloBottom",activeLayer==0||activeLayer==12?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+11)-ind}px);`' v-for='ind in 5' :key='`bot12${ind}`' v-if='pointList.length>=12'></div>
                    <div :class='["siloBottom",activeLayer==0||activeLayer==13?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+12)-ind}px);`' v-for='ind in 5' :key='`bot13${ind}`' v-if='pointList.length>=13'></div>
                    <div :class='["siloBottom",activeLayer==0||activeLayer==14?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+13)-ind}px);`' v-for='ind in 5' :key='`bot14${ind}`' v-if='pointList.length>=14'></div>
                    <div :class='["siloBottom",activeLayer==0||activeLayer==15?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+14)-ind}px);`' v-for='ind in 5' :key='`bot15${ind}`' v-if='pointList.length>=15'></div>
                    <div :class='["siloBottom",activeLayer==0||activeLayer==16?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+15)-ind}px);`' v-for='ind in 5' :key='`bot16${ind}`' v-if='pointList.length>=16'></div>
                    <div :class='["siloBottom",activeLayer==0||activeLayer==17?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+16)-ind}px);`' v-for='ind in 5' :key='`bot17${ind}`' v-if='pointList.length>=17'></div>
                    <div :class='["siloBottom",activeLayer==0||activeLayer==18?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+17)-ind}px);`' v-for='ind in 5' :key='`bot18${ind}`' v-if='pointList.length>=18'></div>
                    <div :class='["siloBottom",activeLayer==0||activeLayer==19?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+18)-ind}px);`' v-for='ind in 5' :key='`bot19${ind}`' v-if='pointList.length>=19'></div>
                    <div :class='["siloBottom",activeLayer==0||activeLayer==20?"":"isNotsiloBottom"]' :style='`transform: rotateX(90deg) translateZ(${250-(400/pointList.length)*(0.5+19)-ind}px);`' v-for='ind in 5' :key='`bot20${ind}`' v-if='pointList.length==20'></div>
                  </div>
                  <canvas id="palette" width="20" height="256"></canvas>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <el-dialog
      title="选择时间"
      :visible.sync="showDatePicker"
      :custom-class='"dialog-setBg dialog-setBg2"'>
      <div class='formWrap'>
        <el-form label-width="100px">
          <div class='dialog-setWrap dialog-setWrap-grainMac'>
            <el-form-item label="选择月份" v-if="isContrast">
              <el-date-picker
                v-model="contrastDateVal"
                type="month"
                @change="getMothGrain"
                placeholder="选择月"
                value-format="yyyy-MM">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="选择月份" v-else>
              <el-date-picker
                v-model="dateVal"
                type="month"
                placeholder="选择月"
                value-format="yyyy-MM">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="采集时间" v-if="isContrast">
              <el-select v-model="contrastGrainId" placeholder="请选择采集时间">
                <el-option 
                  :label="item.batchNo" 
                  :value="item.grainId" 
                  v-for='item in contrastList' 
                  :key='item.grainId'>
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item class='saveBtn'>
            <el-button @click="showDatePicker=false">取 消</el-button>
            <el-button 
              type="primary" 
              @click="getContrastGrain" 
              v-if="isContrast">确 定</el-button>
            <el-button 
              type="primary" 
              @click="updateBatchNo" 
              v-else>确 定</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title="选择仓房" 
      :visible.sync="isShowGrainCheckbox"
      :close-on-click-modal='false'
      :custom-class='"dialog-setBg grainMoreTemp"'>
      <el-form ref="allWareListInfo" :model="allWareListInfo">
        <div class='dialog-setWrap'>
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <el-form-item>
            <el-checkbox-group v-model="allWareListInfo.wareIdList" @change='handleCheckedWareChange'>
              <div class='commonItem grainItemsmall' v-for='item in allWareList' :key='item.wareId'>
                <el-checkbox :label="item.wareId">{{item.wareName}}
                  <div :class='item.wareType==0?"grainWareImgsmall":"grainSiloImgsmall"'></div>
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div class='dialog-setWrap' style='margin-top:10px;padding-bottom:18px' v-if='isPrint'>
          <div>采集时间：
            <el-date-picker
              v-model="printDate"
              type="date"
              placeholder="选择要打印的日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>
        </div>
        <el-form-item class="moreHarvestStatus">
          <el-button type="primary" @click="startHarvestStatus" v-if='isPrint'>预览</el-button>
          <el-button type="primary" @click="startHarvestStatus" v-else>采集</el-button>
          <el-button @click='isShowGrainCheckbox=false'>取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import axios from '../../axios.js'
import createSocket from '../../webSocket.js'
import transform from '../../exportExcel.js'
import {keepNum} from '../../utils/libMethods.js'
export default {
  props:{
    width:Number,
    height:Number,
    type:String
  },
  dicts:['food_type','food_level'],
  data(){
    return{
      activeName:'second',
      pickInfo:{
        wareId:'',
        grainId:'',
        wareType:'0'
      },
      wareList:[],
      batchNoList:[],
      grainLayerList:[],
      grainInfo:{},
      grainDataInfo:{},
      activeLayer:0,
      pointList:[],
      dateVal:'',
      contrastDateVal:'',
      leavalX:0,
      leavalY:0,
      siloGen:0,
      siloQuan:0,
      tempStatus:0,
      isFirstGrain:true,
      isFirstChange:true,
      showDatePicker:false,
      isInit:true,
      isPrint:false,
      isShowGrainCheckbox:false,
      checkAll:false,
      isIndeterminate:false,
      allTotal:0,
      allWareId:[],
      allWareList:[],
      allWareListInfo:{
        wareIdList:[]
      },
      printDate:'',
      cacheInfo:{},
      date:'',
      markDate:[],
      waterSwitch:false,
      ws:null,
      wareInfo:{},
      errorInfo:'',
      foodFariety:[],
      heightInfo:{},
      isContrast:false,//是否对比
      contrastList:[],
      contrastGrainId:null,
    }
  },
  created(){
    this.getWareList();
    let printInfo=JSON.parse(localStorage.getItem('printGrainInfo'));
    let waterInfo=JSON.parse(localStorage.getItem('waterInfo'));
    if(waterInfo){
      this.waterSwitch=waterInfo.waterType;
    }
    this.cacheInfo=printInfo;
    localStorage.removeItem('printGrainInfo');
    localStorage.removeItem('waterInfo');
    axios.get('/system/foodoiltype/getFoodOilTypeSelect').then(res=>{
      if(res){
        let data=res.data;
        this.foodFariety=data.foodTypeList.map(item=>{
          return{
            label:item.foodName,
            value:item.dataId.toString()
          }
        });
      }
    })
  },
  destroyed(){
    this.ws.close()
  },
  computed:{
    setLieWidth:function(){
      let num=(this.width-100)/(this.siloGen+1)>100?100:((this.width-100)/(this.siloGen+1)<50?50:(this.width-100)/(this.siloGen+1))
      return num
    },
    getTempStatus:function(){
      let status=this.tempStatus==0?"空闲":(this.tempStatus==1?"采集中":(this.tempStatus==2?"采集完成":(this.tempStatus==3?"采集失败":"离线")))
      return status
    },
    setMark:function(){
      return (obj)=>{
        let flag='';
        if(this.type=='water'){
          if(this.waterSwitch){
            if(obj.humMark){
              flag=obj.humMark
            }
          }else{
            if(obj.waterMark){
              flag=obj.waterMark
            }
          }
        }else{
          if(obj.mark){
            flag=obj.mark
          }
        }
        return flag
      }
    },
    setStyle:function(){
      return (obj)=>{
        let flag='';
        if(this.type=='water'){
          if(this.waterSwitch){
            if(obj.hum=="备用"||obj.hum=="故障"||obj.hum==""||obj.hum==null){
              flag="#9eacb9"
            }else{
              flag=`rgb(${obj.humColor})`
            }
          }else{
            if(obj.water=="备用"||obj.water=="故障"||obj.water==""||obj.water==null){
              flag="#9eacb9"
            }else{
              flag=`rgb(${obj.waterColor})`
            }
          }
        }else{
          if(obj.value=="备用"||obj.value=="故障"||obj.value==""||obj.value==null){
            flag="#9eacb9"
          }else{

            flag=`rgb(${obj.color})`
          }
        }
        return flag
      }
    }
  },
  methods:{
    socket(){
      this.ws=createSocket('/websocket/grainStatus')
      this.ws.onmessage=this.wsMessage;
    },
    getWareList(){
      axios.get('/system/house/getHouseSelect').then(res=>{
        if(res.code==200){
          this.wareList=res.data;
          let def=this.cacheInfo?this.cacheInfo.wareId:res.data[0].wareId;
          this.allTotal=res.data.length;
          let arr=[],arr1=[],arr2=[]
          res.data.forEach((item,index)=>{
            if(item.wareId==def){
              this.pickInfo.wareId=item.wareId;
              this.pickInfo.wareType=item.wareType;
            }
            arr.push(item.wareId)
            if(item.wareType==0){
              arr1.push(item)
            }else{
              arr2.push(item)
            }
          })
          this.allWareId=arr
          this.allWareList=[...arr1,...arr2];
          this.getBatchNo();
          this.getWareInfo()
          this.socket();
          this.sendId()
        }
      })
    },
    updateBatchNo(){
      if(this.dateVal){
        this.getBatchNo();
        this.date=this.dateVal;
        this.cacheInfo=null;
        this.dateVal='';
        this.showDatePicker=false;
      }
    },
    getBatchNo(){
      let params={}
      if(this.cacheInfo){
        params={
          wareId:this.pickInfo.wareId,
          date:this.dateVal?this.dateVal:this.cacheInfo.date
        }
      }else{
        params={
          wareId:this.pickInfo.wareId,
          date:this.dateVal
        }
      }
      if(this.type=='water'){
        params.hasWater=1
      }
      axios.get('/system/grain/getBatchNoSelect',{params:params}).then(res=>{
        if(res.code==200){
          let arr=res.data;
          this.leavalX=0;
          this.leavalY=0;
          this.getWareGrainStatus()
          if(arr.length==0){
            this.pickInfo.grainId='';
            this.grainLayerList=[];
            this.pointList=[];
            this.grainInfo={};
            if(this.isInit){
              if(this.cacheInfo){
                this.batchNoList=[{batchNo:'更多...',grainId:'more'}]
                this.$message({
                  message:'本仓'+this.cacheInfo.date+'无粮温采集数据',
                  type:'warning',
                  duration:1000
                })
              }else{
                this.$message({
                  message:'本仓无粮温采集数据',
                  type:'warning',
                  duration:1000
                })
                this.batchNoList=[]
              }
            }else{
              this.batchNoList=[{batchNo:'更多...',grainId:'more'}]
              this.$message({
                message:'本仓'+params.date+'无粮温采集数据',
                type:'warning',
                duration:1000
              })
            }
          }else{
            if(this.isFirstGrain){
              this.activeLayer=0;
              this.isFirstGrain=false
            }
            arr.push({batchNo:'更多...',grainId:'more'});
            this.batchNoList=arr;
            let def=this.cacheInfo?this.cacheInfo.grainId:arr[0].grainId;
            arr.forEach(item=>{
              if(def==item.grainId){
                this.pickInfo.grainId=item.grainId;
              }
            })
            this.getGrainTemp()
          }
          if(this.cacheInfo){
            this.cacheInfo.date=''
          }
        }
      })
    },
    sendId(){
      if(this.ws.readyState===1){
        this.ws.send(this.pickInfo.wareId);
      }else{
        setTimeout(()=>{
          this.sendId()
        },500)
      }
    },
    wsMessage(res){
      let data=JSON.parse(res.data);
      this.tempStatus=data.tempStatus;
      this.errorInfo=data.errorInfo;
      if(data.tempStatus==2){
        if(this.isFirstChange){
          this.getBatchNo();
          this.isFirstChange=false;
          // setTimeout(()=>{
          //   this.harvestGrain()
          // },100)
        }
      }
    },
    wareIdChange(val){
      this.wareList.forEach(item=>{
        if(item.wareId==val){
          this.pickInfo.wareType=item.wareType
        }
      })
      if(this.cacheInfo){
        this.cacheInfo=null
        this.date=''
      }
      this.isContrast=false;
      this.getBatchNo();
      this.getWareInfo();
      this.sendId()
    },
    grainIdChange(val){
      this.isInit=false
      if(val!='more'){
        this.isContrast=false;
        this.getGrainTemp()
      }
    },
    getWareGrainStatus(){
      axios.get(`/system/house/getHouseStatus/${this.pickInfo.wareId}`).then(data=>{
        this.tempStatus=data.data.tempStatus;
        this.errorInfo=data.errorInfo;
        if(data.data.tempStatus==2){
          if(this.isFirstChange){
            this.getBatchNo();
            this.isFirstChange=false;
          }
        }
      })
    },
    getGrainTemp(){
      this.getHeightInfo()
      axios.get(`/system/grain/${this.pickInfo.grainId}`).then(data=>{
        let imageData=this.setColor()
        this.grainDataInfo=data.data;
        this.grainDataInfo.wareType=this.pickInfo.wareType
        this.grainInfo=this.grainDataInfo;
        let layer=data.data.mirLayer;
        let row=data.data.mirRow;
        let column=data.data.mirColumn;
        let layerList=[{name:"全部",ind:0}];
        let pointList=[];
        let details=data.data.details;
        if(this.pickInfo.wareType==0){
          for(let i=0;i<layer;i++){
            layerList.push({name:"第 "+(i+1)+" 层",ind:i+1})
            let arr=[];
            for(let j=0;j<row;j++){
              let piont=new Array(column).fill({});
              details.forEach(item=>{
                if(item.mirLayer==(i+1)&&item.mirRow==(j+1)){
                  let color=this.palette(256-(Math.ceil(item.temp)+30)*2,imageData);
                  let waterColor=this.palette(128-Math.ceil(1.28*item.water),imageData);
                  let humColor=this.palette(128-Math.ceil(1.28*item.hum),imageData);
                  piont.fill({
                    value:item.temp,
                    mark:item.mark,
                    color:color,
                    water:item.water,
                    hum:item.hum,
                    waterMark:item.waterMark,
                    humMark:item.humMark,
                    waterColor:waterColor,
                    humColor:humColor
                  },item.mirColumn-1,item.mirColumn)
                }
              })
              arr.push(piont)
            }
            pointList.push(arr)
          }
        }else{
          let coilRule=data.data.coilRule.split('-');
          this.siloGen=data.data.mirColumn;
          this.siloQuan=coilRule.length;
          for(let i=0;i<layer;i++){
            layerList.push({name:'第 '+(i+1)+' 层',ind:i+1});
            let n=0;
            let arr=[];
            for(let j=0;j<coilRule.length;j++){
              let piont=new Array(Number(coilRule[j])).fill({});
              if(j>0){
                n+=Number(coilRule[j-1])
              }
              details.forEach(item=>{
                if(item.mirLayer==(i+1)&&item.mirColumn==(j+1)){
                  let color=this.palette(256-(Math.ceil(item.temp)+20)*2,imageData);
                  let waterColor=this.palette(256-Math.ceil(2.56*item.water),imageData);
                  let humColor=this.palette(256-Math.ceil(2.56*item.hum),imageData);
                  piont.fill({
                    value:item.temp,
                    mark:item.mark,
                    color:color,
                    gen:Number(item.mirRow)+n,
                    water:item.water,
                    hum:item.hum,
                    waterMark:item.waterMark,
                    humMark:item.humMark,
                    waterColor:waterColor,
                    humColor:humColor
                  },item.mirRow-1,item.mirRow)
                }
              })
              arr.push(piont)
            }
            pointList.push(arr)
          }
        }
        this.grainLayerList=layerList;
        this.pointList=pointList;
      })
    },
    getHeightInfo(){
      axios.get(`/system/grainOtherInfo/getInfoByWarehouseId/${this.pickInfo.wareId}`).then(res=>{
        if(res){
          console.log(res);
          this.heightInfo=res.data;
        }
      })
    },
    harvestGrain(){
      axios.post('/system/grain/collectionGrain',{wareId:this.pickInfo.wareId}).then(data=>{
        if(data){
          this.isFirstChange=true;
          this.isContrast=false;
          this.$message({
            type: 'success',
            message: '命令发送成功!',
            duration:1000
          });
        }
      })
    },
    harvestMoreGrain(){
      if(this.wareList.length>0){
        // this.allWareListInfo.wareIdList=[];
        // this.checkAll=false;
        // this.isIndeterminate=false;
        this.isShowGrainCheckbox=true;
      }else{
        this.$message({
          type: 'warning',
          message: '未创建仓房，请先去创建仓房!',
          duration:1000
        });
      }
      this.isPrint=false;
      this.isContrast=false;
    },
    startDrag($event){
      let that=this;
      // 开始
      let dom=document.querySelector('body');
      dom.style.cursor='move'
      window.onmousemove=function(event){
        if(that.leavalY<-90){
          that.leavalY=-90
        }else if(that.leavalY>90){
          that.leavalY=90
        }else{
          if(that.leavalY==90){
            if(event.movementX<0){
              that.leavalY+=(event.movementX/10)
            }
          }else if(that.leavalY==-90){
            if(event.movementX>0){
              that.leavalY+=(event.movementX/10)
            }
          }else{
            that.leavalY+=(event.movementX/10)
          }
        }
        if(that.leavalX<-90){
          that.leavalX=-90
        }else if(that.leavalX>90){
          that.leavalX=90
        }else{
          if(that.leavalX==90){
            if(event.movementY>0){
              that.leavalX-=(event.movementY/10)
            }
          }else if(that.leavalX==-90){
            if(event.movementY<0){
              that.leavalX-=(event.movementY/10)
            }
          }else{
            that.leavalX-=(event.movementY/10)
          }
        }
      }
      // 停止
      window.onmouseup = function () {
        window.onmousemove = null;
        dom.style.cursor='default'
        return
      }
    },
    setColor(){
      const canvas=document.getElementById('palette');
      const ctx=canvas.getContext('2d',{ willReadFrequently: true });
      const defaultColorStops={ 0:"#f61005", 0.35:"#fd7c00", 0.7:"#f9e600", 1:"#01dd26"};
      let grad=ctx.createLinearGradient(0,0,0,256);
      for(const key in defaultColorStops){
        grad.addColorStop(key,defaultColorStops[key])
      }
      ctx.fillStyle=grad;
      ctx.fillRect(0,0,20,256);
      let imageData=ctx.getImageData(0,0,1,256).data;
      return imageData
    },
    palette(val,imageData){
      return imageData.slice(val*4,val*4+3)
    },
    handleCheckAllChange(val) {
      this.allWareListInfo.wareIdList = val ? this.allWareId : [];
      this.isIndeterminate = false;
    },
    handleCheckedWareChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.allTotal;
      this.isIndeterminate = checkedCount > 0 && checkedCount <this.allTotal;
    },
    startHarvestStatus(){
      if(this.allWareListInfo.wareIdList.length==0){
        this.$message({
          message:"未选择仓房！",
          type:"error",
          duration:1000
        })
        return
      }
      if(this.isPrint){
        if(!this.printDate){
          this.$message({
            message:"未选择要打印的报表的日期！",
            type:"error",
            duration:1000
          })
          return
        }
        let printInfo={
          wareId:this.pickInfo.wareId,
          grainId:this.pickInfo.grainId,
          date:this.date
        }
        if(this.type=='water'){
          let waterInfo={
            waterType:this.waterSwitch
          } 
          localStorage.setItem('waterInfo',JSON.stringify(waterInfo))
        }
        localStorage.setItem('printGrainInfo',JSON.stringify(printInfo))
        this.$router.push({name:'grainPreView',params:{wareIds:this.allWareListInfo.wareIdList,date:this.printDate}})
        this.printDate=''
      }else{
        axios.post('/system/grain/collectionGrains',this.allWareListInfo.wareIdList).then(data=>{
          if(data){
            this.isFirstChange=true
            this.$message({
              type: 'success',
              message: '命令发送成功!',
              duration:1000
            });
            this.isShowGrainCheckbox=false
          }
        })
      }
    },
    printGrain(){
      if(this.pickInfo.grainId){
        let printInfo={
          wareId:this.pickInfo.wareId,
          grainId:this.pickInfo.grainId,
          date:this.date
        };
        if(this.type=='water'){
          let waterInfo={
            waterType:this.waterSwitch
          } 
          localStorage.setItem('waterInfo',JSON.stringify(waterInfo))
        }
        localStorage.setItem('printGrainInfo',JSON.stringify(printInfo));
        if(this.isContrast){
          let info=JSON.stringify(this.grainInfo)
          this.$router.push({name:'contrastPreView',params:{info:info}})
        }else{
          this.$router.push({name:'grainPreView',params:{wareIds:[this.pickInfo.wareId],grainId:this.pickInfo.grainId}})
        }
      }else{
        this.$message({
          message:'无可打印的数据，请重新选择',
          type:'warning',
          duration:1000
        })
      }
      
    },
    printMoreGrain(){
      if(this.wareList.length>0){
        this.allWareListInfo.wareIdList=[];
        this.checkAll=false;
        this.isIndeterminate=false;
        this.isShowGrainCheckbox=true;
        this.isPrint=true
      }else{
        this.$message({
          type: 'warning',
          message: '未创建仓房，请先去创建仓房!',
          duration:1000
        });
      }
    },
    grainExcel(){
      let info=this.grainInfo;
      info.pointList=this.pointList;
      let name='',waterType='';
      if(this.type=='water'){
        if(this.waterSwitch){
          name=info.wareName+'湿度信息'
          waterType='hum'
        }else{
          name=info.wareName+'水分信息'
          waterType='water'
        }
      }else{
        name=info.wareName+'粮温信息'
      }
      transform(info,name,this.pickInfo.wareType,waterType) 
    },
    canclBatchNo(val){
      if(this.pickInfo.grainId=='more'&&val==false){
        let date=new Date();
        let year=date.getFullYear();
        let params={
          wareId:this.pickInfo.wareId,
          year:year
        }
        axios.get('/system/grain/queryByYear',{params:params}).then(res=>{
          if(res.code==200){
            this.markDate=res.data
          }
        })
        this.showDatePicker=true;
        this.isContrast=false;
      }
    },
    getWareInfo(){
      axios.get(`/system/house/${this.pickInfo.wareId}`).then(res=>{
        if(res){
          this.wareInfo=res.data;
        }
      })
    },
    harvestContrast(){
      this.showDatePicker=true;
      this.isContrast=true;
    },
    getMothGrain(){
      axios.get('/system/grain/getBatchNoSelect',{params:{wareId:this.pickInfo.wareId,date:this.contrastDateVal}}).then(res=>{
        if(res.code==200){
          let arr=res.data;
          if(arr.length==0){
            this.$message({
              message:'本仓'+this.contrastDateVal+'无粮温采集数据',
              type:'warning',
              duration:1000
            })          
          }else{
            this.contrastList=arr;
          }
        }
      })
    },
    getContrastGrain(){
      axios.get(`/system/grain/${this.contrastGrainId}`).then(data=>{
        let contrastInfo=data.data;
        let contrastGrain=data.data;
        contrastGrain.wareType=this.pickInfo.wareType;
        let layer=data.data.mirLayer;
        let row=data.data.mirRow;
        let column=data.data.mirColumn;
        let humidityIn1=this.grainDataInfo.humidityIn=='备用'||this.grainDataInfo.humidityIn=='故障'||this.grainDataInfo.humidityIn==''||this.grainDataInfo.humidityIn==null?0:this.grainDataInfo.humidityIn;
        let humidityIn2=contrastInfo.humidityIn=='备用'||contrastInfo.humidityIn=='故障'||contrastInfo.humidityIn==''||contrastInfo.humidityIn==null?0:contrastInfo.humidityIn;
        let humidityOut1=this.grainDataInfo.humidityOut=='备用'||this.grainDataInfo.humidityOut=='故障'||this.grainDataInfo.humidityOut==''||this.grainDataInfo.humidityOut==null?0:this.grainDataInfo.humidityOut;
        let humidityOut2=contrastInfo.humidityOut=='备用'||contrastInfo.humidityOut=='故障'||contrastInfo.humidityOut==''||contrastInfo.humidityOut==null?0:contrastInfo.humidityOut;
        let tempIn1=this.grainDataInfo.tempIn=='备用'||this.grainDataInfo.tempIn=='故障'||this.grainDataInfo.tempIn==''||this.grainDataInfo.tempIn==null?0:this.grainDataInfo.tempIn;
        let tempIn2=contrastInfo.tempIn=='备用'||contrastInfo.tempIn=='故障'||contrastInfo.tempIn==''||contrastInfo.tempIn==null?0:contrastInfo.tempIn;
        let tempOut1=this.grainDataInfo.tempOut=='备用'||this.grainDataInfo.tempOut=='故障'||this.grainDataInfo.tempOut==''||this.grainDataInfo.tempOut==null?0:this.grainDataInfo.tempOut;
        let tempOut2=contrastInfo.tempOut=='备用'||contrastInfo.tempOut=='故障'||contrastInfo.tempOut==''||contrastInfo.tempOut==null?0:contrastInfo.tempOut;
        let tempMax1=this.grainDataInfo.tempMax=='备用'||this.grainDataInfo.tempMax=='故障'||this.grainDataInfo.tempMax==''||this.grainDataInfo.tempMax==null?0:this.grainDataInfo.tempMax;
        let tempMax2=contrastInfo.tempMax=='备用'||contrastInfo.tempMax=='故障'||contrastInfo.tempMax==''||contrastInfo.tempMax==null?0:contrastInfo.tempMax;
        let tempMin1=this.grainDataInfo.tempMin=='备用'||this.grainDataInfo.tempMin=='故障'||this.grainDataInfo.tempMin==''||this.grainDataInfo.tempMin==null?0:this.grainDataInfo.tempMin;
        let tempMin2=contrastInfo.tempMin=='备用'||contrastInfo.tempMin=='故障'||contrastInfo.tempMin==''||contrastInfo.tempMin==null?0:contrastInfo.tempMin;
        let tempAve1=this.grainDataInfo.tempAve=='备用'||this.grainDataInfo.tempAve=='故障'||this.grainDataInfo.tempAve==''||this.grainDataInfo.tempAve==null?0:this.grainDataInfo.tempAve;
        let tempAve2=contrastInfo.tempAve=='备用'||contrastInfo.tempAve=='故障'||contrastInfo.tempAve==''||contrastInfo.tempAve==null?0:contrastInfo.tempAve;
        let humMax1=this.grainDataInfo.humMax=='备用'||this.grainDataInfo.humMax=='故障'||this.grainDataInfo.humMax==''||this.grainDataInfo.humMax==null?0:this.grainDataInfo.humMax;
        let humMax2=contrastInfo.humMax=='备用'||contrastInfo.humMax=='故障'||contrastInfo.humMax==''||contrastInfo.humMax==null?0:contrastInfo.humMax;
        let humMin1=this.grainDataInfo.humMin=='备用'||this.grainDataInfo.humMin=='故障'||this.grainDataInfo.humMin==''||this.grainDataInfo.humMin==null?0:this.grainDataInfo.humMin;
        let humMin2=contrastInfo.humMin=='备用'||contrastInfo.humMin=='故障'||contrastInfo.humMin==''||contrastInfo.humMin==null?0:contrastInfo.humMin;
        let humAve1=this.grainDataInfo.humAve=='备用'||this.grainDataInfo.humAve=='故障'||this.grainDataInfo.humAve==''||this.grainDataInfo.humAve==null?0:this.grainDataInfo.humAve;
        let humAve2=contrastInfo.humAve=='备用'||contrastInfo.humAve=='故障'||contrastInfo.humAve==''||contrastInfo.humAve==null?0:contrastInfo.humAve;
        let waterMax1=this.grainDataInfo.humMax=='备用'||this.grainDataInfo.humMax=='故障'||this.grainDataInfo.humMax==''||this.grainDataInfo.humMax==null?0:this.grainDataInfo.humMax;
        let waterMax2=contrastInfo.waterMax=='备用'||contrastInfo.waterMax=='故障'||contrastInfo.waterMax==''||contrastInfo.waterMax==null?0:contrastInfo.waterMax;
        let waterMin1=this.grainDataInfo.waterMin=='备用'||this.grainDataInfo.waterMin=='故障'||this.grainDataInfo.waterMin==''||this.grainDataInfo.waterMin==null?0:this.grainDataInfo.waterMin;
        let waterMin2=contrastInfo.waterMin=='备用'||contrastInfo.waterMin=='故障'||contrastInfo.waterMin==''||contrastInfo.waterMin==null?0:contrastInfo.waterMin;
        let waterAve1=this.grainDataInfo.waterAve=='备用'||this.grainDataInfo.waterAve=='故障'||this.grainDataInfo.waterAve==''||this.grainDataInfo.waterAve==null?0:this.grainDataInfo.waterAve;
        let waterAve2=contrastInfo.waterAve=='备用'||contrastInfo.waterAve=='故障'||contrastInfo.waterAve==''||contrastInfo.waterAve==null?0:contrastInfo.waterAve;
        contrastGrain.humidityIn=keepNum(humidityIn1-humidityIn2,1);
        contrastGrain.humidityOut=keepNum(humidityOut1-humidityOut2,1);
        contrastGrain.tempIn=keepNum(tempIn1-tempIn2,1);
        contrastGrain.tempOut=keepNum(tempOut1-tempOut2,1);
        contrastGrain.tempMax=keepNum(tempMax1-tempMax2,1);
        contrastGrain.tempMin=keepNum(tempMin1-tempMin2,1);
        contrastGrain.tempAve=keepNum(tempAve1-tempAve2,1);
        contrastGrain.humMax=keepNum(humMax1-humMax2,1);
        contrastGrain.humMin=keepNum(humMin1-humMin2,1);
        contrastGrain.humAve=keepNum(humAve1-humAve2,1);
        contrastGrain.waterMax=keepNum(waterMax1-waterMax2,1);
        contrastGrain.waterMin=keepNum(waterMin1-waterMin2,1);
        contrastGrain.waterAve=keepNum(waterAve1-waterAve2,1);
        contrastGrain.infos=this.grainDataInfo.infos.map((item,index)=>{
          let tempMax1=item.tempMax=='备用'||item.tempMax=='故障'||item.tempMax==''||item.tempMax==null?0:item.tempMax;
          let tempMax2=contrastInfo.details[index].tempMax=='备用'||contrastInfo.details[index].tempMax=='故障'||contrastInfo.details[index].tempMax==''||contrastInfo.details[index].tempMax==null?0:contrastInfo.details[index].tempMax;
          let tempMin1=item.tempMin=='备用'||item.tempMin=='故障'||item.tempMin==''||item.tempMin==null?0:item.tempMin;
          let tempMin2=contrastInfo.details[index].tempMin=='备用'||contrastInfo.details[index].tempMin=='故障'||contrastInfo.details[index].tempMin==''||contrastInfo.details[index].tempMin==null?0:contrastInfo.details[index].tempMin;
          let tempAve1=item.tempAve=='备用'||item.tempAve=='故障'||item.tempAve==''||item.tempAve==null?0:item.tempAve;
          let tempAve2=contrastInfo.details[index].tempAve=='备用'||contrastInfo.details[index].tempAve=='故障'||contrastInfo.details[index].tempAve==''||contrastInfo.details[index].tempAve==null?0:contrastInfo.details[index].tempAve;
          let infoHumMax1=item.infoHumMax=='备用'||item.infoHumMax=='故障'||item.infoHumMax==''||item.infoHumMax==null?0:item.infoHumMax;
          let infoHumMax2=contrastInfo.details[index].infoHumMax=='备用'||contrastInfo.details[index].infoHumMax=='故障'||contrastInfo.details[index].infoHumMax==''||contrastInfo.details[index].infoHumMax==null?0:contrastInfo.details[index].infoHumMax;
          let infoHumMin1=item.infoHumMin=='备用'||item.infoHumMin=='故障'||item.infoHumMin==''||item.infoHumMin==null?0:item.infoHumMin;
          let infoHumMin2=contrastInfo.details[index].infoHumMin=='备用'||contrastInfo.details[index].infoHumMin=='故障'||contrastInfo.details[index].infoHumMin==''||contrastInfo.details[index].infoHumMin==null?0:contrastInfo.details[index].infoHumMin;
          let infoHumAve1=item.infoHumAve=='备用'||item.infoHumAve=='故障'||item.infoHumAve==''||item.infoHumAve==null?0:item.infoHumAve;
          let infoHumAve2=contrastInfo.details[index].infoHumAve=='备用'||contrastInfo.details[index].infoHumAve=='故障'||contrastInfo.details[index].infoHumAve==''||contrastInfo.details[index].infoHumAve==null?0:contrastInfo.details[index].infoHumAve;
          let infoWaterMax1=item.infoWaterMax=='备用'||item.infoWaterMax=='故障'||item.infoWaterMax==''||item.infoWaterMax==null?0:item.infoWaterMax;
          let infoWaterMax2=contrastInfo.details[index].infoWaterMax=='备用'||contrastInfo.details[index].infoWaterMax=='故障'||contrastInfo.details[index].infoWaterMax==''||contrastInfo.details[index].infoWaterMax==null?0:contrastInfo.details[index].infoWaterMax;
          let infoWaterMin1=item.infoWaterMin=='备用'||item.infoWaterMin=='故障'||item.infoWaterMin==''||item.infoWaterMin==null?0:item.infoWaterMin;
          let infoWaterMin2=contrastInfo.details[index].infoWaterMin=='备用'||contrastInfo.details[index].infoWaterMin=='故障'||contrastInfo.details[index].infoWaterMin==''||contrastInfo.details[index].infoWaterMin==null?0:contrastInfo.details[index].infoWaterMin;
          let infoWaterAve1=item.infoWaterAve=='备用'||item.infoWaterAve=='故障'||item.infoWaterAve==''||item.infoWaterAve==null?0:item.infoWaterAve;
          let infoWaterAve2=contrastInfo.details[index].infoWaterAve=='备用'||contrastInfo.details[index].infoWaterAve=='故障'||contrastInfo.details[index].infoWaterAve==''||contrastInfo.details[index].infoWaterAve==null?0:contrastInfo.details[index].infoWaterAve;
          item.tempMax=keepNum(tempMax1-tempMax2,1);
          item.tempMin=keepNum(tempMin1-tempMin2,1);
          item.tempAve=keepNum(tempAve1-tempAve2,1);
          item.infoHumMax=keepNum(infoHumMax1-infoHumMax2,1);
          item.infoHumMin=keepNum(infoHumMin1-infoHumMin2,1);
          item.infoHumAve=keepNum(infoHumAve1-infoHumAve2,1);
          item.infoWaterMax=keepNum(infoWaterMax1-infoWaterMax2,1);
          item.infoWaterMin=keepNum(infoWaterMin1-infoWaterMin2,1);
          item.infoWaterAve=keepNum(infoWaterAve1-infoWaterAve2,1);
          return item;
        })
        contrastGrain.details=this.grainDataInfo.details.map((item,index)=>{
          let temp1=item.temp=='备用'||item.temp=='故障'||item.temp==''||item.temp==null?0:item.temp;
          let temp2=contrastInfo.details[index].temp=='备用'||contrastInfo.details[index].temp=='故障'||contrastInfo.details[index].temp==''||contrastInfo.details[index].temp==null?0:contrastInfo.details[index].temp;
          let hum1=item.hum=='备用'||item.hum=='故障'||item.hum==''||item.hum==null?0:item.hum;
          let hum2=contrastInfo.details[index].hum=='备用'||contrastInfo.details[index].hum=='故障'||contrastInfo.details[index].hum==''||contrastInfo.details[index].hum==null?0:contrastInfo.details[index].hum;
          let water1=item.water=='备用'||item.water=='故障'||item.water==''||item.water==null?0:item.water;
          let water2=contrastInfo.details[index].water=='备用'||contrastInfo.details[index].water=='故障'||contrastInfo.details[index].water==''||contrastInfo.details[index].water==null?0:contrastInfo.details[index].water;
          item.temp=keepNum(temp1-temp2,1);
          item.hum=keepNum(hum1-hum2,1);
          item.water=keepNum(water1-water2,1);
          return item
        })
        this.contrastGrain=contrastGrain;
        this.grainInfo=contrastGrain;
        let details=contrastGrain.details;
        let imageData=this.setColor();
        let pointList=[];
        if(this.pickInfo.wareType==0){
          for(let i=0;i<layer;i++){
            let arr=[];
            for(let j=0;j<row;j++){
              let piont=new Array(column).fill({});
              details.forEach(item=>{
                if(item.mirLayer==(i+1)&&item.mirRow==(j+1)){
                  let color=this.palette(256-(Math.ceil(item.temp)+30)*2,imageData);
                  let waterColor=this.palette(128-Math.ceil(1.28*item.water),imageData);
                  let humColor=this.palette(128-Math.ceil(1.28*item.hum),imageData);
                  piont.fill({
                    value:item.temp,
                    mark:item.mark,
                    color:color,
                    water:item.water,
                    hum:item.hum,
                    waterMark:item.waterMark,
                    humMark:item.humMark,
                    waterColor:waterColor,
                    humColor:humColor
                  },item.mirColumn-1,item.mirColumn)
                }
              })
              arr.push(piont)
            }
            pointList.push(arr)
          }
        }else{
          let coilRule=data.data.coilRule.split('-');
          this.siloGen=data.data.mirColumn;
          this.siloQuan=coilRule.length;
          for(let i=0;i<layer;i++){
            let n=0;
            let arr=[];
            for(let j=0;j<coilRule.length;j++){
              let piont=new Array(Number(coilRule[j])).fill({});
              if(j>0){
                n+=Number(coilRule[j-1])
              }
              details.forEach(item=>{
                if(item.mirLayer==(i+1)&&item.mirColumn==(j+1)){
                  let color=this.palette(256-(Math.ceil(item.temp)+20)*2,imageData);
                  let waterColor=this.palette(256-Math.ceil(2.56*item.water),imageData);
                  let humColor=this.palette(256-Math.ceil(2.56*item.hum),imageData);
                  piont.fill({
                    value:item.temp,
                    mark:item.mark,
                    color:color,
                    gen:Number(item.mirRow)+n,
                    water:item.water,
                    hum:item.hum,
                    waterMark:item.waterMark,
                    humMark:item.humMark,
                    waterColor:waterColor,
                    humColor:humColor
                  },item.mirRow-1,item.mirRow)
                }
              })
              arr.push(piont)
            }
            pointList.push(arr)
          }
        }
        this.pointList=pointList;
        this.showDatePicker=false;
      })
    }
  }
}
</script>

<style>
  .harvestGrain{
    left: 15px;
  }
  .moreGrain{
    left: 140px;
  }
  .contrast{
    left: 275px;
  }
  .printMoreGrain{
    left: 545px;
  }
  .harvestStatus{
    position: absolute;
    top:15px;
    font-weight: 600;
    right:15px;
    line-height: 43px;
    width: 100px;
    height: 43px;
    line-height: 40px;
    text-align: center;
    font-size: 14px;
    border-radius: 4px;
  }
  .harvestStatus1{
    background: rgba(57,255,53,0.12);
    color: #53DB50
  }
  .harvestStatus2{
    background: rgba(53,98,255,0.12);
    color: #3562FF;
  }
  .harvestStatus3{
    background: rgba(242,169,59,0.12);
    color: #F2A93B
  }
  .harvestStatus4{
    background: rgba(242,59,59,0.12);
    color: #F23B3B
  }
  .harvestStatus5{
    background: rgba(128, 128, 128, 0.12);
    color: gray
  }
  .harvestTime{
    position: absolute;
    top:30px;
    font-size: 12px;
    color: rgba(0,0,0,0.5);
    right: 150px;
  }
  .errorInfo{
    position: absolute;
    top: 65px;
    font-size: 12px;
    color: #F23B3B;
    right: 30px;
  }
  .wareTempInfo{
    display: flex;
    align-items: center;
    position: absolute;
    z-index: 100;
    right:25px;
    top:86px;
    font-size: 12px;
    height:50px;
  }
  .grainTempHum{
    height: 24px;
    line-height: 24px;
    margin-left: 30px;
    display: flex;
    align-items: center
  }
  .grainTempHum span{
    display: inline-block;
    width:55px;
    height: 20px;
    line-height: 20px;
    text-align:center;
    background: rgba(217,217,217,0.23);
    font-family: 'ledsolid';
    font-size: 20px
  }
  .checkLayerWrap{
    height: 50px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding-left: 20px;
    border-bottom: 1px solid rgba(0,0,0,0.1)
  }
  .checkLayerWrap .el-form-item{
    margin-bottom: 0 !important;
    font-weight: 500
  }
  .harvestTempWrap{
    height: 50px;
    position: absolute;
    top: -4px;
    right: 0px;
    display: flex;
    font-size: 12px;
    align-items: center;
  }
  .allTempWrap{
    height: 50px;
    display: flex;
    font-size: 12px;
    align-items: center;
  }
  .harvestTempWrap span,.allTempWrap span{
    display: block;
    width: 100px;
    text-align: center
  }
  .harvestVal{
    font-size: 24px;
    font-family: 'DINPro-Bold';
    color: #000;
  }
  .grainDataTable{
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    padding: 10px;
  }
  .allGrain{
    justify-content: flex-start;
  }
  .layerGrain{
    justify-content: center
  }
  .siloGrain{
    justify-content: flex-start;
    align-items: flex-start
  }
  .ceng{
    display: flex;
    flex-direction: column;
    text-align: center;
    border-left: 1px solid rgba(0,0,0,0.1);
    border-top: 1px solid rgba(0,0,0,0.1);
  }
  .layerTitle{
    height: 50px;
    font-weight: 600;
    line-height: 50px;
    border-right: 1px solid rgba(0,0,0,0.1);
    border-top: none
  }
  .cengWrap:first-child .layerTitle{
    border-top: 1px solid rgba(0,0,0,0.1)
  }
  .siloCengWrap{
    border-left: 1px solid rgba(0,0,0,0.1);
    border-top: 1px solid rgba(0,0,0,0.1)
  }
  .siloTabTitle{
    height:40px;
    min-width: 50px;
    flex-shrink: 0;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    border-right: 1px solid rgba(0,0,0,0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box
  }
  .hang{
    display: flex;
  }
  .siloQuan{
    display: flex
  }
  .lie{
    height:40px;
    min-width: 50px;
    max-width: 100px;
    flex-shrink: 0;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    border-right: 1px solid rgba(0,0,0,0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box
  }
  .max{
    background-color: red !important;
    color: white
  }
  .min{
    background-color: #01dd26 !important;
    color: white
  }
  .grain3DWrap{
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    background-color: #F6F7FC;
    display: flex;
    align-items: center;
    justify-content: center;
    perspective: 2000px;
  }
  .check3DLayerWrap{
    position: absolute;
    left: 20px;
    height: 50px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    top: 0;
    z-index: 1000;
  }
  .check3DLayerWrap .el-form-item{
    margin-bottom: 0 !important;
    font-weight: 500
  }
  .ware3DWrap{
    height: 500px;
    width: 800px;
    position: relative;
    transform-style: preserve-3d;
  }
  .ware3DWrap>div{
    position: absolute;
    -webkit-user-select: none;
    -moz-user-select: none;
    -o-user-select: none;
    user-select: none;
  }
  .wareLeftfront{
    width: 10px;
    height: 500px;
    background: #FFFFFF;
    transform: translateZ(250px)
  }
  .wareLeftleft{
    height: 500px;
    width: 500px;
    background: #efefef;
    transform: rotateY(-90deg) translateZ(250px)
  }
  .wareLeftright{
    height: 500px;
    width: 500px;
    background: #efefef;
    transform: rotateY(-90deg) translateZ(240px)
  }
  .wareLefttop{
    width: 10px;
    height: 500px;
    background: #e4e4e4;
    transform: rotateX(90deg) translateZ(250px);
  }
  .wareBackfront{
    width: 800px;
    height: 500px;
    background: #eeecec;
    transform: translateZ(-240px)
  }
  .wareBackright{
    height: 500px;
    width: 10px;
    background: #d8d8d8;
    transform: rotateY(-90deg) translateZ(-795px) translateX(-245px)
  }
  .wareBacktop{
    height: 10px;
    width: 800px;
    background: #e4e4e4;
    transform: rotateX(90deg) translateZ(5px) translateY(-245px);
  }
  .wareBottomtop{
    height: 500px;
    width: 800px;
    background: #e0e0e0;
    transform: rotateX(90deg) translateZ(-250px);
  }
  .wareBottombottom{
    height: 500px;
    width: 800px;
    background: #e0e0e0;
    transform: rotateX(90deg) translateZ(-260px);
  }
  .wareBottomfront{
    width:800px;
    height: 10px;
    transform: translateZ(250px) translateY(500px);
    background:#cdcdcd;
  }
  .wareBottomleft{
    width: 500px;
    height: 10px;
    transform: rotateY(90deg) translateZ(-250px) translateY(500px);
    background: #b6b6b6;
  }
  .wareBottomright{
    width: 500px;
    height: 10px;
    transform: rotateY(90deg) translateZ(550px) translateY(500px);
    background: #b6b6b6;
  }
  .wareRightfront{
    width: 10px;
    height: 500px;
    background: rgba(255, 255, 255, 0.153);
    transform: translateZ(250px) translateX(790px);
  }
  .wareRightright{
    height: 500px;
    width: 500px;
    background: #d8d8d836;
    transform: rotateY(-90deg) translateZ(-550px)
  }
  .wareRighttop{
    width: 10px;
    height: 500px;
    background: #e4e4e431;
    transform: rotateX(90deg) translateZ(250px) translateX(790px);
  }
  .wareToptop{
    width: 800px;
    height: 500px;
    transform: rotateX(90deg) translateZ(250px);
  }
  .wareTopfront{
    width: 800px;
    height: 10px;
    background: #e4e4e42d;
    transform: translateZ(250px)
  }
  .wareDataShow{
    width: 780px;
    height: 490px;
    display: flex;
    flex-direction:column-reverse;
  }
  .isTempDataShow{
    background: #dfdfdf;
  }
  .dataShowGen{
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    flex-direction: row-reverse
  }
  .dataShowLie{
    flex-grow: 1;
    flex-basis: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #dfdfdf;
    height: 100%;
    padding: 1px;
    box-sizing: border-box;
  }
  .dataShowValue{
    background: #9eacb9;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 12px
  }
  .wareDataShowfront{
    width: 780px;
    height: 10px;
    background: rgba(255, 255, 255, 0.153);
  }
  .iswareDataShowfront{
    background: #b6bfd3;
  }
  .wareDateShowright{
    height: 10px;
    width: 500px;
    background: rgba(255, 255, 255, 0.153);
  }
  .iswareDataShowright{
    background: #c8c8c8;
  }
  .wareCengWrap{
    height: 500px;
    width: 50px;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-weight: 600;
    color: rgba(0,0,0,0.5);
    transform: translateZ(250px) translateX(-50px);
    justify-content: space-around;
    align-items: center
  }
  .wareLieWrap{
    width:800px;
    height: 20px;
    display: flex;
    font-size: 12px;
    font-weight: 600;
    color: rgba(0,0,0,0.5);
    transform: translateZ(260px) translateY(510px);
    justify-content: space-around;
    align-items: center;
    flex-direction: row-reverse
  }
  .wareHangWrap{
    width: 50px;
    height: 500px;
    transform: rotateX(90deg) translateZ(-250px) translateX(800px);
    display: flex;
    font-size: 12px;
    font-weight: 600;
    color: rgba(0,0,0,0.5);
    flex-direction:column-reverse;
    justify-content: space-around;
    align-items: center;
  }
  .wareCengItem,.wareHangItem,.wareLieItem{
    display: flex;
    justify-content: center;
    align-items: center;
    padding:2px;
    background: #d6ddff;
    border-radius: 3px;
  }
  .silo3DWrap{
    height: 400px;
    width: 500px;
    position: relative;
    transform-style: preserve-3d;
  }
  .silo3DWrap>div{
    position: absolute;
    -webkit-user-select: none;
    -moz-user-select: none;
    -o-user-select: none;
    user-select: none;
  }
  .siloWall{
    height: 400px;
    width: 500px;
    border-left: 1px solid #8d8d8d3b;
    border-right: 1px solid #8d8d8d3b;
  }
  .siloBottom{
    border: 1px solid;
    height: 500px;
    width: 500px;
    border-radius: 50%;
    background: #b6bfd3
  }
  .isNotsiloBottom{
    background:none;
    border: 1px solid rgba(255, 255, 255, 0.23)
  }
  .siloTop{
    border:1px solid rgba(0,0,0,0.1);
    background: #b6bfd317
  }
  .siloDataShow{
    background: #9fc7A1;
    border: none;

  }
  .siloDataShowWarp{
    height: 100%;
    width: 100%;
    border-radius: 50%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .siloDataQuanWrap{
    border: 1px solid white;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
  }
  .siloDataQuan{
    position: absolute;
    background-color: rgba(222, 206, 151, 0.53);
    border-radius: 50%;
  }
  .siloDataLie{
    background-color:#2ebf2e;
    height:50px;
    width:50px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    position: absolute;
    z-index: 2;
    left: 50%;
    top: 0;
    color: white;
    margin: -20px 0 0 -20px;
  }
  .printGrain{
    left: 410px;
  }
  .grainExcel{
    left: 680px;
  }
  #palette{
    position: absolute;
    left: 10px;
    bottom: 10px;
  }
  .unitTips{
    position: absolute;
    bottom: 10px;
    left: 10px;
  }
  .grainItemsmall{
    width: 125px;
    height: 75px;
    margin-right: 10px;
    margin-left: 3px;
    margin-top: 10px;
    margin-bottom: 3px
  }
  .grainWareImgsmall{
    width: 59px;
    height: 41px;
    background-image: url('../../assets/grain/checkWareHouse.png');
    background-size: cover;
    position: absolute;
    bottom: -42px;
    left: 55px;
  }
  .grainSiloImgsmall{
    height: 41px;
    width:33px;
    background-image: url("../../assets/grain/checkSquatSilo.png");
    background-size: cover;
    position: absolute;
    bottom: -42px;
    left: 75px;
  }
  .grainItemsmall .el-checkbox{
    position: absolute;
    left: 5px;
    top: 5px;
    line-height: 0
  }
  .grainItemsmall .is-checked .grainWareImgsmall{
    background-image: url('../../assets/ware/wareHouse.png');
  }
  .grainItemsmall .is-checked .grainSiloImgsmall{
    background-image: url("../../assets/ware/squatSilo.png");
  }
  .grainWareName{
    font-size: 14px;
    font-weight: 600;
    position: absolute;
    bottom: 10px
  }
  .grainMoreTemp{
    width: 743px !important;
  }
  .grainMoreTemp .dialog-setWrap{
    flex-direction: column;
    padding-right: 0px
  }
  .moreHarvestStatus{
    padding: 10px 0px 20px 10px;
    text-align: end
  }
  
  .datePickerWrap{
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 20px !important
  }
  .layerCard{
    position: absolute;
    right: 0px;
    top: 10px;
    display: flex;
    font-size: 14px;
  }
  .layerCard .layerItemVal{
    font-size: 18px;
    font-family: 'DINPro-Bold';
    color: #000;
    width: 100px;
    text-align: center
  }
  .layerCard .layerItemName{
    width: 100px;
    text-align: center
  }
  .grain3DWrap .cardWrap{
    border: 1px solid rgba(0,0,0,0.1);
    width: 180px;
    position: absolute;
    right: 10px;
    bottom: 10px;
    font-size: 12px;
    font-weight: 600;
    color: rgba(0,0,0,.5)
  }
  .grain3DWrap .cardHead{
    height: 30px;
    line-height: 30px;
    text-align: center;
    background-color: rgba(48,56,255,0.03);
    color: #000;
    border-bottom: 1px solid rgba(0,0,0,0.1);
  }
  .grain3DWrap .cardItem{
    border-bottom: 1px solid rgba(0,0,0,0.1);
    display: flex;
  }
  .grain3DWrap .cardItem:last-child{
    border: none;
  }
  .grain3DWrap .cardItem .cardName{
    width: 60px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border-right: 1px solid rgba(0,0,0,0.1)
  }
  .grain3DWrap .cardItem .cardValue{
    width: 120px;
    height: 30px;
    line-height:30px;
    color: rgba(0,0,0,.8);
    padding-left: 10px;
    box-sizing: border-box
  }
</style>
